import type { ViewStyle } from 'react-native';

// Web only: a DOM element blocks pointer events for anything painted below it,
// so the card content must be made transparent for the card-wide link to be
// reachable. Interactive descendants opt back in via postCardInteractiveStyle.
export const postCardContentStyle: ViewStyle = {
  position: 'relative',
  zIndex: 1,
  pointerEvents: 'none'
};

export const postCardInteractiveStyle: ViewStyle = {
  pointerEvents: 'auto'
};

// Siblings of the overlay link that must stay above it.
export const postCardActionsStyle: ViewStyle = {
  position: 'relative',
  zIndex: 1
};
